module.exports = __webpack_public_path__ + "img/perfil.9bcfadee.jpg";